import AuthService from "./auth.service";

export default function checkRole(roleToHave) {
  const { role } = AuthService.getCurrentUser();
  return roleToHave === role;
}
